import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { t as translate } from "../lib/i18n";
import { api } from "../lib/api";
import { supabase } from "../lib/supabase";

const I18nContext = createContext(null);

export function I18nProvider({ children, initialLocale }) {
  const [locale, setLocale] = useState(() => {
    if (initialLocale) return initialLocale;
    const stored = localStorage.getItem("locale");
    if (stored) return stored;
    
    if (typeof window !== "undefined" && window.location.hostname.endsWith(".ru")) {
      return "ru";
    }
    return "en";
  });

  console.log("I18nProvider render, locale:", locale);

  useEffect(() => {
    localStorage.setItem("locale", locale);
  }, [locale]);

  const changeLocale = useCallback((l) => {
    console.log("changeLocale called with:", l);
    setLocale(l);
    supabase.auth.getSession().then(({ data }) => {
      if (data?.session) {
        api.patch("/auth/locale", { locale: l }).catch(() => {});
      }
    });
  }, []);

  const t = useCallback((k) => translate(locale, k), [locale]);

  return (
    <I18nContext.Provider value={{ locale, setLocale: changeLocale, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
